module.exports = __webpack_public_path__ + "img/andong_detail.67c1e381.jpg";